import { SquareTerminal } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";
import { ARCHETIPI } from "@/data/simulatorArchetypes";
import { ArchetypeCard } from "@/components/candidati/archetipi/ArchetypeCard";

export const ArchetipiGallery = ({ onOpenSim }) => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="archetipi-section">
    <div className="max-w-7xl mx-auto">
      <Reveal variant="tech" className="mb-14 lg:mb-20">
        <Eyebrow className="mb-6">Galleria Archetipi</Eyebrow>
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1] text-4xl sm:text-5xl lg:text-6xl" data-testid="archetipi-title">
          12 archetipi. Uno è il tuo.
        </h2>
        <p className="mt-6 max-w-xl text-base md:text-lg text-titanium leading-relaxed">
          Ogni archetipo nasce dall'incontro di due dimensioni dominanti. Qual è il tuo? Il simulatore te lo dice in pochi minuti.
        </p>
        <span className="tech-line mt-8" />
      </Reveal>
      <div className="grid grid-cols-1 min-[480px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-5" data-testid="archetipi-grid">
        {Object.entries(ARCHETIPI).map(([id, a], i) => (
          <Reveal key={id} delay={(i % 4) * 90} className="h-full">
            <ArchetypeCard id={id} archetype={a} />
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14 lg:mt-20 flex justify-center">
        <button
          type="button"
          onClick={onOpenSim}
          aria-haspopup="dialog"
          className="cta cta-mega glass group inline-flex items-center justify-center gap-3 rounded-full border px-8 sm:px-12 py-4 sm:py-5 text-sm sm:text-base font-bold tracking-[0.12em] uppercase text-white"
          data-testid="archetipi-cta"
        >
          <SquareTerminal className="h-5 w-5 text-cyan" strokeWidth={1.75} />
          Scopri il tuo archetipo
        </button>
      </Reveal>
    </div>
  </section>
);
